var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outcome-container"},[_c('p',{staticClass:"text--l"},[_vm._v(_vm._s(_vm.outcomeText))]),_c('div',{staticClass:"spacer--l"}),_c('a-btn',{on:{"click":_vm.actionHandler}},[_vm._v(_vm._s(_vm.buttonLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }